const WORK_TYPE_AVG_LENGTH = 30;

export const isWorkTypeAvgLength = (workType: string): boolean =>
	workType.length < WORK_TYPE_AVG_LENGTH;
